module.exports = __webpack_public_path__ + "img/speech.f3e9521.svg";